if (!customElements.get('press-carousel')) {
  customElements.define('press-carousel', class PressCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const carousel = this.querySelector('.js-press-carousel-carousel')
      const carouselSlides = carousel.querySelectorAll('.swiper-slide')
      if (carouselSlides.length < 1) return

      const logoList = [...carouselSlides].map(el => ({
        logoImage: el.getAttribute('data-logo-image'),
        logoImageAlt: el.getAttribute('data-logo-image-alt')
      }))

      return new Swiper(carousel.querySelector('.swiper'), {
        cssMode: false,
        slidesPerView: 1,
        loop: carouselSlides.length > 1,
        speed: 600,
        pagination: {
          el: carousel.querySelector('.swiper-pagination'),
          clickable: true,
          renderBullet: function (index, className) {
            return `<button type="button" class="press-carousel__logo ${className}">
              <img class="press-carousel__logo-image" src="${logoList[index].logoImage}" alt="${logoList[index].logoImageAlt}" />
            </button>`
          }
        },
        navigation: {
          nextEl: carousel.querySelector('.swiper-button-next'),
          prevEl: carousel.querySelector('.swiper-button-prev')
        },
      })
    }
  });
}